export const cdnImageUrl = 'https://ddh86g38imawj.cloudfront.net/'
